import {
    createColumnDate,
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect
    // createColumnTreeSelect
} from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { putField } from "../../../../../utils/form";
// import { callRequestDepartment } from "../../../storage-location/request/requestor/requestor.section";
import { callDocumentStatus } from "../../../storage-location/storage-location/storage-location.section";
import store from "../../../../../store";

export const callHazMgtType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_MGT_TYPE", value: searchQuery });

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.report.docType"),
            dataIndexValue: () => i18n.global.t("views.report.hazMgt"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refHaz"),
            dataIndex: "storageLocations.0.refHaz.approveCode",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazMgt.refType"),
            dataIndex: "refType.value",
            inputProp: () => ({ list: callHazMgtType, optLabel: "value" }),
            search: { visible: () => true, name: "refType.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocation"),
            dataIndex: "storageLocations.0.refStorageLocation.name",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocationSub"),
            dataIndex: "storageLocations.0.refStorageLocationSub.buildingName",
            align: "center",
            width: 200,
            search: { visible: () => false }
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("views.manufacture.amount"),
            dataIndex: "storageLocations.0.amount",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refPackage"),
            dataIndexValue: ({ record }) => {
                const storageLocation = record.storageLocations[0];
                return (
                    [storageLocation?.refPackage1?.value, storageLocation?.refPackage2?.value, storageLocation?.refPackage3?.value]
                        .filter(d => d !== undefined)
                        .join(" : ") +
                    " " +
                    [storageLocation?.size, storageLocation?.refUnit?.value].filter(d => d !== undefined).join(" ")
                );
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            inputProp: () => ({ list: () => [], optLabel: "value" }),
            search: { visible: () => false },
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("views.manufacture.createDate"),
            dataIndex: "createDate",
            align: "center",
            search: { visible: () => false }
        }),
        // createColumnInput({
        //     title: () => i18n.global.t("model.haz.refUserCompany"),
        //     dataIndex: "refFrom.companyNameTh",
        //     dataIndexValue: ({ record }) =>
        //         record.refFromUser?.refPersonType?.key === "1" ? record.refFromUser?.companyNameTh : record.refFromUser?.fullNameTh,
        //     customRender: ({ record, column }) => column.dataIndexValue({ record })
        // }),
        // createColumnTreeSelect({
        //     title: () => i18n.global.t("model.request.refDepartment"),
        //     dataIndex: "refDepartment.nameTh",
        //     inputProp: () => ({
        //         list: () => callRequestDepartment({ refRequestDocKey: "31" }),
        //         renderLabel: ({ item }) => (
        //             <div>
        //                 {item.fullCode} : {item.nameTh}
        //             </div>
        //         ),
        //         filterWhere: ({ value }) => [
        //             { name: "fullCode", operator: "like", value },
        //             { logic: "OR", name: "nameTh", operator: "like", value }
        //         ],
        //         treeDefaultExpandAll: true
        //     }),
        //     search: { visible: () => false, name: "refDepartment.id" },
        //     width: 200
        // }),
        createColumnInput({ title: () => i18n.global.t("model.haz.tradeNameTh"), dataIndex: "storageLocations.0.refHaz.tradeNameTh" }),
        createColumnDate({ title: () => i18n.global.t("views.report.docEffectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        // createColumnDate({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "expireDate", align: "center" }),
        // createColumnInput({
        //     title: () => i18n.global.t("views.report.docTimeLive"),
        //     dataIndexValue: () => "-",
        //     customRender: ({ record, column }) => column.dataIndexValue({ record }),
        //     align: "center",
        //     search: { visible: () => false }
        // }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
